import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="tech-grid-light bg-canvas py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-226" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-227" data-mp="j8hvog9c8xea">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-228" data-mp="1guxdjj5ofx2d">
          Todo lo que incluye:
        </h2>
        <p className="mt-3 text-center text-navy-700" data-id="element-229" data-mp="1bx5mercuwez8">
          {productShortName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-navy-900" data-id="element-230" data-mp="16uy65pkzucr3">{price}</b>
        </p>

        <ul className="mt-10 grid gap-x-8 rounded-xl border border-navy-100 bg-white p-6 sm:grid-cols-2 sm:p-8" data-id="element-231" data-mp="12vxs0kdgnyaf">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-navy-50 py-3 text-sm font-semibold text-navy-900" data-id="element-232" data-mp="3rknjtz9ynsi7">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-leaf-500" data-id="element-233" data-mp="3ice8l4j665zk">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-234" data-mp="3nay0dlkg2bzu" />
              </span>
              {feature}
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-sun-400 bg-navy-900 px-6 py-5 text-center text-lg font-bold leading-relaxed text-white" data-id="element-235" data-mp="3ddjkbn2fnp82">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}